import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BioOferta, ServicoBio } from '../services/servico-bio.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-bio-ofertas',
  templateUrl: './bio-ofertas.component.html',
  styleUrls: ['./bio-ofertas.component.scss']
})
export class BioOfertasComponent implements OnInit {

  ofertas: BioOferta[] = [];
  carregando = true;
  idBioPagina: number;
  slugBioPagina: string;
  exibirOfertas = true;
  modoExibicaoOfertas: 'slide' | 'lista' = 'slide';
  modoPreview: 'mobile' | 'desktop' = 'mobile';
  urlPreview: SafeResourceUrl;
  timestampPreview = Date.now();

  constructor(
    private servicoBio: ServicoBio,
    private autorizacaoService: AutorizacaoService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.autorizacaoService.fetchUser().subscribe(usuario => {
      if (!usuario?.empresa?.id) {
        this.carregando = false;
        this.mostrarNotificacao('Não foi possível carregar os dados da empresa.', 'error');
        return;
      }

      this.servicoBio.obterBioPagina(usuario.empresa.id).then((data: any) => {
        if (data && data.id) {
          this.idBioPagina = data.id;
          this.slugBioPagina = data.slug;
          this.exibirOfertas = data.exibirOfertas !== false;
          this.modoExibicaoOfertas = data.modoExibicaoOfertas === 'lista' ? 'lista' : 'slide';
          this.atualizarUrlPreview();
          this.carregarOfertas();
        } else {
          this.carregando = false;
        }
      }).catch(() => {
        this.carregando = false;
      });
    });
  }

  carregarOfertas() {
    this.carregando = true;
    this.servicoBio.obterOfertas(this.idBioPagina).then((data: BioOferta[]) => {
      this.ofertas = data || [];
      this.carregando = false;
      this.recarregarPreview();
    }).catch(() => {
      this.carregando = false;
      this.mostrarNotificacao('Erro ao carregar ofertas sincronizadas.', 'error');
    });
  }

  sincronizarOfertas() {
    this.carregando = true;
    this.servicoBio.sincronizarOfertas().then((data: BioOferta[]) => {
      this.ofertas = data || [];
      this.carregando = false;
      this.recarregarPreview();
      this.mostrarNotificacao('Lista de ofertas sincronizada com sucesso.', 'success');
    }).catch(() => {
      this.carregando = false;
      this.mostrarNotificacao('Erro ao sincronizar ofertas da Bio.', 'error');
    });
  }

  alterarExibicaoOferta(oferta: BioOferta, exibirNaBio: boolean) {
    const estadoAnterior = oferta.exibirNaBio;
    oferta.exibirNaBio = exibirNaBio;

    this.servicoBio.atualizarOferta(oferta.id, { ...oferta } as BioOferta).then((ofertaAtualizada: BioOferta) => {
      Object.assign(oferta, ofertaAtualizada || { exibirNaBio });
      this.recarregarPreview();
      this.mostrarNotificacao(
        oferta.exibirNaBio
          ? 'Oferta adicionada à Link Bio.'
          : 'Oferta removida da Link Bio.',
        'success'
      );
    }).catch(() => {
      oferta.exibirNaBio = estadoAnterior;
      this.mostrarNotificacao('Erro ao atualizar a exibição da oferta.', 'error');
    });
  }

  atualizarUrlPreview() {
    if (!this.slugBioPagina) {
      this.urlPreview = null;
      return;
    }
    const url = window.location.origin + '/bio/' + this.slugBioPagina + '?preview=true&t=' + this.timestampPreview;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  recarregarPreview() {
    this.timestampPreview = Date.now();
    this.atualizarUrlPreview();
  }

  abrirEmNovaAba() {
    if (!this.slugBioPagina) return;
    window.open(window.location.origin + '/bio/' + this.slugBioPagina, '_blank');
  }

  toggleExibirOfertas() {
    this.exibirOfertas = !this.exibirOfertas;
    this.servicoBio.atualizarBioPagina(this.idBioPagina, { exibirOfertas: this.exibirOfertas } as any).then(() => {
      this.recarregarPreview();
      this.mostrarNotificacao(
        this.exibirOfertas ? 'Ofertas ativadas na página Bio!' : 'Ofertas desativadas na página Bio.',
        'success'
      );
    }).catch(() => {
      this.exibirOfertas = !this.exibirOfertas;
      this.mostrarNotificacao('Erro ao atualizar configuração.', 'error');
    });
  }

  alterarModoExibicaoOfertas(modo: 'slide' | 'lista') {
    if (!this.idBioPagina || this.modoExibicaoOfertas === modo) return;

    const modoAnterior = this.modoExibicaoOfertas;
    this.modoExibicaoOfertas = modo;

    this.servicoBio.atualizarBioPagina(this.idBioPagina, { modoExibicaoOfertas: modo } as any).then(() => {
      this.recarregarPreview();
      this.mostrarNotificacao(
        modo === 'slide'
          ? 'Ofertas configuradas para exibição em slide.'
          : 'Ofertas configuradas para exibição em lista de produtos.',
        'success'
      );
    }).catch(() => {
      this.modoExibicaoOfertas = modoAnterior;
      this.mostrarNotificacao('Erro ao atualizar modo de exibição das ofertas.', 'error');
    });
  }

  private mostrarNotificacao(mensagem: string, tipo: 'success' | 'error') {
    this.notificationService.show({
      content: mensagem,
      type: { style: tipo, icon: true },
      position: { horizontal: 'right', vertical: 'top' },
      hideAfter: 3000
    });
  }
}
